import React from 'react';
import { Tabs } from '@fikasio/react-ui-components';
import { useTranslation } from 'react-i18next';
import { Entity } from 'services/entities/types';
import { useGetItemsForEntityQuery } from 'services/items/api';
import ItemsView from '../items/ItemsView';
import EntityInformationsForm from './EntityInformationsForm';
import EntityFieldsTable from './EntityFieldsTable';

export interface EntityViewProps {
  defaultTab?: string,
  entity: Entity,
}

const EntityView = ({
  defaultTab,
  entity,
}: EntityViewProps) => {
  const { t } = useTranslation();
  const { data: items } = useGetItemsForEntityQuery(entity.id);

  return (
    <div>
      <Tabs
        className="mb-3"
        defaultValue={defaultTab || 'ITEMS'}
        options={[
          {
            content: (
              <ItemsView
                entity={entity}
                items={items?.filter(i => i.entityId === entity.id)}
              />
            ),
            label: t('items'),
            value: 'ITEMS',
          },
          {
            content: (
              <EntityInformationsForm
                entity={entity}
              />
            ),
            label: t('informations'),
            value: 'INFOS',
          },
          {
            content: (
              <EntityFieldsTable
                entity={entity}
              />
            ),
            label: t('fields'),
            value: 'FIELDS',
          },
        ]}
      />
    </div>
  );
}

export default EntityView;
